/**
 * Bundle hero scarcity.
 * - Remaining starts at 85–90% of total sets (persisted per browser).
 * - Decreases every 10–15 seconds across visits and while the tab is open.
 * - Drops by 1 extra while the customer has all required pieces selected.
 */

const STORAGE_KEY = 'rvnche-bundle-scarcity';
const MIN_REMAINING_RATIO = 0.08;
const DECAY_MIN_MS = 10 * 1000;
const DECAY_MAX_MS = 15 * 1000;

let baseRemaining = 0;
let setsTotal = 0;
let bundleComplete = Boolean(window.__rvncheBundleSelection?.complete);
let decayTimer = null;

function seedRemaining(total) {
  const ratio = 0.85 + Math.random() * 0.05;
  return Math.max(1, Math.round(total * ratio));
}

function floorRemaining(total) {
  return Math.max(1, Math.round(total * MIN_REMAINING_RATIO));
}

function nextDecayMs() {
  return DECAY_MIN_MS + Math.random() * (DECAY_MAX_MS - DECAY_MIN_MS);
}

function readState() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
  } catch {
    return null;
  }
}

function writeState(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* ignore */
  }
}

function applyTimeDecay(state, now = Date.now()) {
  let remaining = state.remaining;
  let updatedAt = state.updatedAt || now;
  const floor = floorRemaining(state.total);

  while (remaining > floor && now - updatedAt >= DECAY_MIN_MS) {
    /* Catch up for time away using mid interval so offline decay doesn't race. */
    const step = (DECAY_MIN_MS + DECAY_MAX_MS) / 2;
    const ticks = Math.floor((now - updatedAt) / step);
    if (ticks <= 0) break;
    remaining = Math.max(floor, remaining - ticks);
    updatedAt += ticks * step;
  }

  return { ...state, remaining, updatedAt };
}

function ensureState(total) {
  let state = readState();

  if (!state || state.total !== total || typeof state.remaining !== 'number') {
    state = {
      total,
      remaining: seedRemaining(total),
      updatedAt: Date.now(),
    };
  } else {
    state = applyTimeDecay(state);
  }

  writeState(state);
  return state;
}

function paint() {
  const remaining = Math.max(0, baseRemaining - (bundleComplete ? 1 : 0));
  const percent = setsTotal > 0 ? Math.min(100, Math.round((remaining / setsTotal) * 100)) : 0;

  document.querySelectorAll('[data-bundle-offer]').forEach((offer) => {
    const remainingEl = offer.querySelector('[data-sets-remaining]');
    if (remainingEl) remainingEl.textContent = String(remaining);

    const fill = offer.querySelector('[data-progress-fill]');
    const bar = offer.querySelector('[data-progress]');
    if (fill) fill.style.width = `${percent}%`;
    if (bar) bar.setAttribute('aria-valuenow', String(percent));
  });
}

function scheduleDecay() {
  clearTimeout(decayTimer);
  decayTimer = setTimeout(() => {
    if (setsTotal <= 0) {
      scheduleDecay();
      return;
    }

    const state = ensureState(setsTotal);
    const floor = floorRemaining(setsTotal);

    if (state.remaining > floor) {
      state.remaining -= 1;
      state.updatedAt = Date.now();
      writeState(state);
      baseRemaining = state.remaining;
      paint();
    }

    scheduleDecay();
  }, nextDecayMs());
}

function syncFromDom() {
  const offer = document.querySelector('[data-bundle-offer]');
  if (!offer) return;

  setsTotal = Number(offer.dataset.setsTotal || 0);
  if (setsTotal <= 0) return;

  baseRemaining = ensureState(setsTotal).remaining;
  paint();
}

document.addEventListener('rvnche:bundle-selection', (event) => {
  bundleComplete = Boolean(event.detail?.complete);
  paint();
});

syncFromDom();
scheduleDecay();
